"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
require("./SelectGuestComponent.scss");
const react_bootstrap_icons_1 = require("react-bootstrap-icons");
const QuantityComponent_1 = __importDefault(require("../quantityComponent/QuantityComponent"));
const constants_1 = require("../../../assets/constants/constants");
const SelectGuestComponent = ({ baseName, form, minRooms = 1, maxRooms = constants_1.MAX_ROOMS_PER_CHECKOUT, initialQtyRooms = constants_1.DEFAULT_ROOMS_PER_CHECKOUT, minGuests = 1, maxGuests = constants_1.MAX_GUESTS_PER_ROOM, initialQtyGuests = constants_1.DEFAULT_GUESTS_PER_ROOM, customClass, onChange = () => { }, }) => {
    const [qtyText, setQtyText] = (0, react_1.useState)('');
    const updateText = () => {
        const qtyRooms = form.getFieldValue(`${baseName}Rooms`);
        const qtyGuests = form.getFieldValue(`${baseName}Guests`);
        const text = `${qtyRooms} suíte${qtyRooms > 1 ? 's' : ''} ${qtyGuests} hóspede${qtyGuests > 1 ? 's' : ''}`;
        setQtyText(text);
    };
    (0, react_1.useEffect)(() => {
        form.setFieldsValue({
            [`${baseName}Rooms`]: initialQtyRooms,
            [`${baseName}Guests`]: initialQtyGuests,
        });
        updateText();
    }, [initialQtyRooms, initialQtyGuests]);
    return (react_1.default.createElement("div", { className: customClass || 'SelectGuestComponent' },
        react_1.default.createElement(antd_1.Popover, { placement: "bottom", overlayClassName: "SelectGuestComponent-item", content: react_1.default.createElement("div", { className: "item-line-container" },
                react_1.default.createElement(QuantityComponent_1.default, { name: `${baseName}Rooms`, form: form, title: "Su\u00EDtes", min: minRooms, max: maxRooms, initialQty: initialQtyRooms, updateText: updateText, onChange: onChange }),
                react_1.default.createElement(QuantityComponent_1.default, { name: `${baseName}Guests`, form: form, title: "H\u00F3spedes", min: minGuests, max: maxGuests, initialQty: initialQtyGuests, updateText: updateText, onChange: onChange })), title: "" },
            react_1.default.createElement("div", { className: "select-content noselect" },
                react_1.default.createElement("span", { className: "person-icon" },
                    react_1.default.createElement(react_bootstrap_icons_1.PersonFill, { color: "#000" })),
                qtyText)),
        react_1.default.createElement(antd_1.Form.Item, { style: { display: 'none' }, name: `${baseName}Rooms`, initialValue: initialQtyRooms },
            react_1.default.createElement(antd_1.InputNumber, { style: { display: 'none' }, min: minRooms, max: maxRooms })),
        react_1.default.createElement(antd_1.Form.Item, { style: { display: 'none' }, name: `${baseName}Guests`, initialValue: initialQtyGuests },
            react_1.default.createElement(antd_1.InputNumber, { style: { display: 'none' }, min: minGuests, max: maxGuests }))));
};
exports.default = SelectGuestComponent;
